import React, { useState } from "react";
import Button from "../elements/Button";
import Title from "../elements/Title";
import { FaLinkedinIn, FaGithub, FaTwitter, FaArrowUp } from "react-icons/fa";
import { Fade } from "react-reveal";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact(props, ref) {
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const [isSending, setisSending] = useState(false);

  const sendMessage = (e) => {
    e.preventDefault();
    setisSending(true);
    emailjs
      .sendForm(
        "metker",
        "portfolio-template",
        e.target,
        "user_HdR1gmuaU3G56sG4MmDtH"
      )
      .then(
        (result) => {
          setisSending(false);
          console.log(result.text);
          toast.dark("Message sent successfully!", {
            position: "bottom-center",
          });
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <section className="px-3 py-10 container mx-auto relative" ref={ref}>
      <Title title="Leave a message" caption="How can I help you?" />
      <form onSubmit={sendMessage} className="message-form md:mx-auto">
        <Fade left cascade>
          <div>
            <div className="py-2">
              <input
                className="h-12 w-full border-black px-4 border border-gray-500 py-1"
                type="text"
                placeholder="Name"
                name="name"
                required
              />
            </div>
            <div className="py-2">
              <input
                className="h-12 w-full border-black px-4 border border-gray-500 py-1"
                type="email"
                placeholder="Email"
                name="email"
                required
              />
            </div>
            <div className="py-2">
              <textarea
                name="message"
                cols="30"
                rows="4"
                placeholder="Messages"
                className="w-full border-black px-4 border border-gray-500 py-3"
                required
              ></textarea>
            </div>
          </div>
        </Fade>
        {isSending ? (
          <Button isPrimary isBlock isDisabled>
            <div className="flex p-2">
              <div className="w-3 h-3 bg-white rounded-full animate-bounce mx-auto border-solid border-2 border-black" />
              <div className="w-3 h-3 bg-white rounded-full animate-bounce mx-auto border-solid border-2 border-black" />
              <div className="w-3 h-3 bg-white rounded-full animate-bounce mx-auto border-solid border-2 border-black" />
            </div>
          </Button>
        ) : (
          <Button isPrimary isBlock>
            Send
          </Button>
        )}
      </form>
      <ToastContainer />
      <div className="py-8 flex justify-center">
        <Button
          isPrimary
          type="link"
          href="https://www.linkedin.com/in/gfsani"
          isExternal
          target="_blank"
          isDense
          className="mx-4"
        >
          <FaLinkedinIn />
        </Button>
        <Button
          isPrimary
          type="link"
          href="https://github.com/metkerr"
          isExternal
          target="_blank"
          isDense
          className="mx-4"
        >
          <FaGithub />
        </Button>
        <Button
          isPrimary
          type="link"
          href="https://twitter.com/metkerr"
          isExternal
          target="_blank"
          isDense
          className="mx-4"
        >
          <FaTwitter />
        </Button>
      </div>
      <Button
        onClick={scrollToTop}
        isPrimary
        isDense
        className="absolute right-0 mr-10 mt-8"
      >
        <FaArrowUp />
      </Button>
    </section>
  );
}

const contactRef = React.forwardRef(Contact);
export default contactRef;
